import React from 'react'

const ArticleIcon = () => {
  return (
    <svg
      viewBox="0 0 75 75"
      xmlns="http://www.w3.org/2000/svg"
      className="inline stroke-primary"
      role="img"
      width="40"
      height="40"
      fill="none"
      preserveAspectRatio="xMidYMid meet"
      aria-label="Article Icon"
    >
      <title>Article Icon</title>
      <path
        d="M33.0803 33.0797L52.9675 22.0312L41.9191 41.9187L22.0316 52.9672L33.0803 33.0797Z"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M37.5 68.75C54.7587 68.75 68.75 54.7587 68.75 37.5C68.75 20.2411 54.7587 6.25 37.5 6.25C20.2411 6.25 6.25 20.2411 6.25 37.5C6.25 54.7587 20.2411 68.75 37.5 68.75Z"
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  )
}

export { ArticleIcon }
